import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import charOvershootRotateInGif from '../../../assets/images/transitions/charOvershootRotateIn.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_CHAR_OVERSHOOT_ROTATE_IN = 'charOvershootRotateOut';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const charOvershootRotateOutPresetDetails = {
  // The name of the preset.
  name: PRESET_CHAR_OVERSHOOT_ROTATE_IN,

  // A human friendly name for the preset.
  humanName: 'Character - Overshoot & Rotate Out',

  // A preview of the transition.
  gif: charOvershootRotateInGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'letter.scaleY': {
      time: {
        end: 'end.-500',
        start: 'end.-1500'
      },
      easing: EASINGS.easeInElastic,
      values: [
        1,
        0
      ],
      stagger: '-10',
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_CHAR_OVERSHOOT_ROTATE_IN,
    options: {},
  },
};

charOvershootRotateOutPresetDetails.template.options = lodash.cloneDeep(charOvershootRotateOutPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_CHAR_OVERSHOOT_ROTATE_IN;

// This defines the value of the presets object.
export default charOvershootRotateOutPresetDetails;
